import LebenslaufFirstImage from './assets/lebenslauf-section-first-image.webp';
import LebenslaufSecondImage from './assets/lebenslauf-section-second-image.webp';

export const FIRST_TITLE = 'Verpacke Deine berufliche Story im Lebenslauf';
export const FIRST_TEXT_CONTENT_1 =
  'Der Lebenslauf ist Deine berufliche Story und sollte daher gut strukturiert sein. <strong>Halte es auf einer oder zwei Seiten kurz und konzentriere Dich auf das Wesentliche</strong>. Du kannst ihn <strong>chronologisch oder antichronologisch</strong> ordnen, je nachdem, was Deine Stärken am besten präsentiert. Es ist wichtig, <strong>klare Beweise</strong> für Deine Erfahrungen und Qualifikationen zu liefern, um die Glaubwürdigkeit zu erhöhen.';
export const FIRST_TEXT_CONTENT_2 =
  'Weiterführende Informationen zum Thema Lebenslauf, sowie Tipps und Tricks zur Erstellung findest du hier. Übrigens mit XING kannst du <strong>Deinen Lebenslauf einfach kostenlos erstellen</strong>. <a>Probiere es doch einmal aus!</a>';
export const SECOND_TITLE = 'Runde Deine Bewerbung mit diesen Unterlagen ab';
export const SECOND_TEXT_CONTENT =
  'Eine vollständige Bewerbung ist mehr als nur ein Anschreiben und ein Lebenslauf. Sie beinhaltet auch <strong>relevante Anhänge wie Zeugnisse, Zertifikate</strong> und weitere Nachweise, die Deine Qualifikationen und Fähigkeiten untermauern. Diese Dokumente sind entscheidend, um das Vertrauen des potenziellen Arbeitgebers zu gewinnen.';

export const LebenslaufData = [
  {
    image: LebenslaufFirstImage,
    articleUrl:
      'https://www.xing.com/news/articles/lebenslauf-check-so-gelingt-auch-dir-der-perfekte-cv-aufbau-ohne-fakes-und-fails-5609172',
    thumbnail:
      'Lebenslauf-Check: So gelingt auch Dir der perfekte CV-Aufbau – ohne Fakes und Fails',
    readingTime: '6 Minuten',
    section: 'lebenslauf',
  },
  {
    image: LebenslaufSecondImage,
    articleUrl:
      'https://www.xing.com/news/articles/setz-diese-7-akzente-in-deinem-lebenslauf-um-ihn-fur-personaler-unwiderstehlich-zu-machen-5718120',
    thumbnail:
      'Setz diese 7 Akzente in Deinem Lebenslauf, um ihn für Personaler unwiderstehlich zu machen',
    readingTime: '4 Minuten',
    section: 'lebenslauf',
  },
];
